module.exports = __webpack_public_path__ + "img/academy.e0af9ed6.svg";